import { CxpDeliverableDetail } from '../models';

/**
 * Pre-populates the detail slice with the data already known from the tasks
 * list (name, description, service line, client). The full backend payload
 * arrives later via `LoadCxpDeliverableDetail` and merges in.
 */
export class HydrateCxpDeliverableDetailFromTasks {
  static readonly type = '[CxpDeliverableDetail] Hydrate From Tasks';
  constructor(public readonly partial: Partial<CxpDeliverableDetail> & { id: number }) {}
}

export class LoadCxpDeliverableDetail {
  static readonly type = '[CxpDeliverableDetail] Load';
  constructor(public readonly deliverableId: number) {}
}

export class LoadCxpDeliverableDetailSuccess {
  static readonly type = '[CxpDeliverableDetail] Load Success';
  constructor(public readonly detail: CxpDeliverableDetail) {}
}

export class LoadCxpDeliverableDetailFailure {
  static readonly type = '[CxpDeliverableDetail] Load Failure';
  constructor(public readonly error: unknown) {}
}

export class ClearCxpDeliverableDetail {
  static readonly type = '[CxpDeliverableDetail] Clear';
}

/**
 * Records every file on a deliverable as VIEWED against the legacy
 * `MarkDeliverableFiles` mutation. Dispatched by the state's
 * `loadDetailSuccess` handler whenever a fresh detail payload lands —
 * i.e. the user opened the deliverable detail page.
 *
 * Fire-and-forget side effect; does not modify state.
 */
export class MarkCxpDeliverableViewed {
  static readonly type = '[CxpDeliverableDetail] Mark As Viewed';
  constructor(
    public readonly deliverableId: number,
    public readonly fileIds: number[],
  ) {}
}
